/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 09:57:41
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {DeclareMalfunctionDOI} from "./api/declareMalfunctionApi";
import DeclareMalfunctionService from "./service/declareMalfunctionService";
import './declareMalfunction.less';

@Component({name: 'declare-malfunction'})
export default class DeclareMalfunction extends BasicSearchPage<DeclareMalfunctionService, DeclareMalfunctionDOI.RowDataI, DeclareMalfunctionDOI.QueryRowDataParamsI> {
    checkBoxShow = true
    
    @override
    renderHead(h) {
        return <div></div>
    }
    // rowData = [{ops_number:'1'}]

	@override
	loadService () {
		this.service = new DeclareMalfunctionService(this)
	}
}